import React from 'react';
import Grid from '@mui/material/Grid';
import { CustomMaterialTable } from '../../../common/CustomMaterialTable';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import * as _R from 'ramda';
import {DialogBoxMedium} from '../../../common/dialog.medium';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';

export const StateTaxComponent = (props) => {
    let dataArr = props.Data;
    const {EditPermission:Edit, DeletePermission:Delete} = props;
    let table_size = 10; // Default
    if (dataArr) {
        let data_arr_length = dataArr.length ;
        if (data_arr_length < 10) {
            table_size = data_arr_length < 3 ? 2 : data_arr_length;
        }
    }
    let Open = props.Open;
    return (
        <>
            <React.Fragment>
            <Grid container spacing={3}>
                <Grid item md={12}>
                    <div  className={'mtable-basic'}>
                    <CustomMaterialTable
                        title={props.Title}
                        columns={[
                            {
                                title: 'Start Date',
                                field: 'start_date',
                            },
                            {
                                title: 'End Date',
                                field: 'end_date',
                            },
                            {   
                                title: 'Income Tax State',
                                field: 'income_tax_state_name',
                                
                            },
                            {
                                title:'Unemployment Filing State',
                                field:'unemployment_state_name',
                            },
                            {
                                title:'State Tax Allowances',
                                field:'state_tax_allowances',
                            },
                            {
                                title:'State Tax Exempt Withholding',
                                field:'exempt_label',

                            },
                            {
                                title:'State Tax Extra Withholding',
                                field:'state_tax_extra_withholding',
                            },
                            {
                                title:'State Filing Status',
                                field:'marital_status',
                            
                            }                            
                        ]}
                        data={dataArr}
                        options={{
                            search: false,
                            actionsColumnIndex: -1,
                            toolbar:true,
                            pageSize:table_size,
                            pageSizeOptions: [10,20,30],
                            columnsButton:true,
                        }}
                        actions={[
                             {
                                icon: 'add',
                                tooltip: 'Add State Tax Details',
                                isFreeAction: true,
                                onClick: (event) => { props.OnAdd() },
                                hidden: (Edit) ? false : true,
                            },
                            {
                                icon: 'edit',
                                tooltip: 'Edit',
                                onClick: (event, rowData) => {
                                    props.OnUpdate(rowData.id);
                                },
                                hidden: (Edit) ? false : true,
                            },
                        ]}
                     editable={{
                            isDeletable: rowData => (Delete) ? true : false,
                            onRowDelete: rowData =>
                                new Promise((resolve, reject) => {
                                    setTimeout(() => {
                                    {
                                        let idx = dataArr.findIndex(x => x.id === rowData.id);
                                        props.OnDelete(idx, rowData.id);
                                    }
                                    resolve()
                                    }, 500)
                            }),
                        }}
                    />
                 </div>
                </Grid>
            </Grid>
            
            <DialogBoxMedium
                    Open = {Open}  
                    Cancel = {props.OnClose}
                    Title = {props.IsEditable ? "Edit State Tax Details" : "Add State Tax Component"}
                    OnSubmit = {props.OnSubmit}
                    Content = {<DialogContent FormProps={props}/>}
           />

        </React.Fragment>
        </>
    )
};
const DialogContent = (p) => {
    const {FormProps:props} = p;
    const {FormFields, HandleOnChange} = props;
    return (
            <form className="form-fullwidth" onSubmit={props.OnSubmit}>
            <div className = "error"> {props.Errors.statetax_overlap}</div>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <FormControl>
                            <TextField variant="standard"
                                required
                                id="start_date"
                                name="start_date"
                                label="Start Date"
                                type="date"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={FormFields.start_date}
                                onChange={HandleOnChange}
                                error={props.Errors.start_date && true}
                                helperText={props.Errors.start_date}
                            />
                        </ FormControl>
                    </Grid>
                     <Grid item xs={12} md={6}>
                        <FormControl>
                            <TextField variant="standard"
                                id="end_date"
                                name="end_date"
                                label="End Date"
                                type="date"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={FormFields.end_date}
                                onChange={HandleOnChange}
                                error={props.Errors.end_date && true}
                                helperText={props.Errors.end_date}
                            />
                        </ FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl variant="standard">
                           <InputLabel htmlFor="income_tax_state" required  error={props.Errors.income_tax_state && true}>Income Tax State</InputLabel>
                            <Select
                                value={_R.type(FormFields) !== 'Undefined' && FormFields.income_tax_state}
                                onChange={HandleOnChange}
                                inputProps={{
                                    name: 'income_tax_state',
                                    id: 'income_tax_state',
                                }}>
                                <MenuItem value={null} key={'i-type-0'}>Select</MenuItem>
                                {_R.type(props.AllStates) !== 'Undefined' && props.AllStates.map((t, i) =>
                                    <MenuItem value={t.id} key={'i-type-'+i}>{t.short_code}</MenuItem>
                                )}
                            </Select>
                            {props.Errors.income_tax_state && <FormHelperText className='error'>{props.Errors.income_tax_state}</FormHelperText> }
                        </ FormControl>
                    </Grid>
            <Grid item xs={12} md={6}>
                        <FormControl>
                            <TextField variant="standard"
                                id="state_tax_allowances"
                                name="state_tax_allowances"
                                label="State Tax Allowances"
                                type="number"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={_R.type(FormFields) !== 'Undefined' && FormFields.state_tax_allowances}
                                error={props.Errors.state_tax_allowances && true}
                                onChange={HandleOnChange}
                            />
                        </ FormControl>
                    </Grid>
                <Grid item xs={12} md={6}>
                        <FormControl>
                            <TextField variant="standard"
                                id="state_tax_extra_withholding"
                                name="state_tax_extra_withholding"
                                label="State Tax Extra Withholding"
                                type="number"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={_R.type(FormFields) !== 'Undefined' && FormFields.state_tax_extra_withholding}
                                error={props.Errors.state_tax_extra_withholding && true}
                                onChange={HandleOnChange}
                            />
                        </ FormControl>
                    </Grid>
                <Grid item  xs={12} md={6}>
                        <FormControl variant="standard">
                            <InputLabel htmlFor="state_tax_exempt_withholding" required error={props.Errors.state_tax_exempt_withholding && true}>State Tax Exempt Withholding</InputLabel>
                            <Select
                                value={_R.type(FormFields) !== 'Undefined' && FormFields.state_tax_exempt_withholding}
                                onChange={HandleOnChange}
                                inputProps={{
                                    name: 'state_tax_exempt_withholding',
                                    id: 'state_tax_exempt_withholding',
                                }}>
                                <MenuItem value={null} key={'i-type-0'}>Select</MenuItem>
                                <MenuItem value={"1"} key={'i-type-1'}>Yes</MenuItem>
                                <MenuItem value={"0"} key={'i-type-2'}>No</MenuItem>   
                            </Select>
                           {props.Errors.state_tax_exempt_withholding && <FormHelperText className='error'>{props.Errors.state_tax_exempt_withholding}</FormHelperText> } 
                        </ FormControl>                        
                    </Grid>
                <Grid item xs={12} md={6}>
                        <FormControl variant="standard">
                            <InputLabel htmlFor="state_filing_status"  required  error={props.Errors.state_filing_status && true} >State Tax Filing Status</InputLabel>
                            <Select
                                value={_R.type(FormFields) !== 'Undefined' && FormFields.state_filing_status}
                                onChange={HandleOnChange}
                                inputProps={{
                                    name: 'state_filing_status',
                                    id: 'state_filing_status',
                                }}>
                                <MenuItem value={null} key={'i-type-0'}>Select</MenuItem>
                                 {_R.type(props.MaritalStatuses) !== 'Undefined' && props.MaritalStatuses.map((t, i) =>
                                    <MenuItem value={t.id} key={'m-type-'+i}>{t.title}</MenuItem>
                                )}
                            </Select>
                       {props.Errors.state_filing_status && <FormHelperText className='error'>{props.Errors.state_filing_status}</FormHelperText> }
                        </ FormControl>
                    </Grid>
               <Grid item xs={12} md={6}>
                        <FormControl variant="standard">
                            <InputLabel htmlFor="unemployment_filing_state"  required  error={props.Errors.unemployment_filing_state && true} >Unemployment Filing State</InputLabel>
                            <Select
                                value={_R.type(FormFields) !== 'Undefined' && FormFields.unemployment_filing_state}
                                onChange={HandleOnChange}
                                inputProps={{
                                    name: 'unemployment_filing_state',
                                    id: 'unemployment_filing_state',
                                }}>
                                <MenuItem value={null} key={'i-type-0'}>Select</MenuItem>
                                 {_R.type(props.AllStates) !== 'Undefined' && props.AllStates.map((t, i) =>
                                    <MenuItem value={t.id} key={'m-type-'+i}>{t.short_code}</MenuItem>
                                )}
                            </Select>
                        {props.Errors.unemployment_filing_state && <FormHelperText className='error'>{props.Errors.unemployment_filing_state}</FormHelperText> }
                        </ FormControl>
                    </Grid>

                </Grid>
            </form>
)
}
